import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { UnitProvider } from "./context/UnitContext";
import LoginPage from "./pages/LoginPage";
import WorkoutPage from "./pages/WorkoutPage";
import ProgramPage from "./pages/ProgramPage";
import ProgressPage from "./pages/ProgressPage";
import HistoryPage from "./pages/HistoryPage";
import AdminPage from "./pages/AdminPage";
import InvitePage from "./pages/InvitePage";
import ProfilePage from "./pages/ProfilePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import InscriptionPage from "./pages/InscriptionPage";
import { ChangePasswordModal } from "./components/ChangePasswordModal";
import { BottomNav } from "./components/BottomNav";
import { InstallGuide } from "./components/InstallGuide";
import { SplashScreen } from "./components/SplashScreen";

const Shell = () => {
  const { user, updateUser } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <p className="font-display text-3xl text-[#FF3B30] animate-pulse">GYMTRACK</p>
      </div>
    );
  }
  if (user === false) {
    return (
      <Routes>
        <Route path="/invite/:token" element={<InvitePage />} />
        <Route path="/inscription" element={<InscriptionPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }
  return (
    <div className="max-w-md mx-auto min-h-screen bg-black sm:border-x sm:border-[#2E2E3A]">
      {user.must_change_password && (
        <ChangePasswordModal forced onChanged={() => updateUser({ must_change_password: false })} />
      )}
      <Routes>
        <Route path="/" element={<WorkoutPage />} />
        <Route path="/programme" element={<ProgramPage />} />
        <Route path="/progression" element={<ProgressPage />} />
        <Route path="/historique" element={<HistoryPage />} />
        <Route path="/profil" element={<ProfilePage />} />
        <Route path="/admin" element={user.role === "admin" ? <AdminPage /> : <Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
      <InstallGuide />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <UnitProvider>
      <BrowserRouter>
        <SplashScreen />
        <Shell />
        <Toaster position="top-center" theme="dark" toastOptions={{
          style: { background: "#1C1C1E", border: "1px solid rgba(255,255,255,0.15)", color: "#fff" },
        }} />
      </BrowserRouter>
      </UnitProvider>
    </AuthProvider>
  );
}

export default App;
